import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 1440px;
  padding: 0 20px;
  margin: 0 auto;
`;
